import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CheckCircle } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden" data-id="element-152">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-gold-dark/20 via-black to-black -z-10" data-id="element-153"></div>

      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="w-full" data-id="element-155">
          <div className="inline-block px-3 py-1 rounded-full border border-gold/30 bg-gold/10 text-gold-light font-medium text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-156">
            💃 DANCE TECHNIQUE TEACHER READY™
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6" data-id="element-157">
            100 Ready-to-Teach Jazz, Contemporary & Musical Theatre Classes —{' '}
            <span className="text-gold-gradient" data-id="element-158">
              Built for the Teacher Who's Done Planning From Scratch.
            </span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="relative w-full max-w-[260px] sm:max-w-md md:max-w-xl mb-4 sm:mb-6" data-id="element-159">
          <div className="absolute inset-0 bg-gold/20 blur-[80px] rounded-full" data-id="element-160"></div>
          <img src="https://cdn.magicpatterns.com/uploads/6pmaDJY3NDJ683fbGCxN5s/seguridad_e_higiene_(4).png" alt="Dance Technique Teacher Ready™ — Complete Teaching Library" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-161" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="w-full" data-id="element-162">
          <p className="text-sm sm:text-lg md:text-xl text-gray-300 leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-163">
            The complete professional dance teaching library — ready to use from
            today.
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-164">
            <Button href="https://dance-technique-teacher-ready.impultienda.ar/checkout" target="_blank" onLinkClick={() => {
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'InitiateCheckout', {
                content_name: 'Dance Technique Teacher Ready Complete Pack',
                value: 27.0,
                currency: 'USD'
              });
            }
          }} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-165">
              🟡 GET THE COMPLETE TEACHING LIBRARY NOW
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-gray-400" data-id="element-166">
            <div className="flex items-center gap-1.5" data-id="element-167">
              <CheckCircle size={14} className="text-gold" data-id="element-168" />
              <span data-id="element-169">Premium Teaching Library</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-170">
              <CheckCircle size={14} className="text-gold" data-id="element-171" />
              <span data-id="element-172">5 Strategic Bonuses</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-173">
              <CheckCircle size={14} className="text-gold" data-id="element-174" />
              <span data-id="element-175">Immediate Access</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}